import PropTypes from 'prop-types';
import React from 'react';
import styles from './styles.module.scss';
import cx from 'classnames';
import DOMPurify from "dompurify";
import _ from 'lodash';
import Button from 'src/components/button';
class NewEmptyMessage extends React.Component {
  constructor(props){
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    if(this.props.onClick){
      this.props.onClick()
    }
  }

  render() {
    if(!this.props.visible){
      return null;
    }

    return (
      <div className={ cx(styles.container, this.props.className) }>
        <div className={ styles.inner }>
          <img src={ this.props.image } />
          <h1>{ this.props.title }</h1>
          {_.get(this.props, "messageElement") ? (
             <p dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.props.messageElement)}}></p>
          ) : (
            <p>{this.props.message}</p>
          )}
          {this.props.buttonText &&
          <Button
            onClick={this.handleClick}
            text={this.props.buttonText}
            className={ styles.button } 
            variant='primary'
            icon={this.props.buttonIcon && this.props.buttonIcon}
          />
          }
        </div>
      </div>
    );
  }
}

NewEmptyMessage.propTypes = {
  title: PropTypes.string,
  mesasge: PropTypes.string,
  visible: PropTypes.bool
};

NewEmptyMessage.defaultProps = {
  title: "Opps!! Something went wrong",
  message: "We are looking into it & keep you posted",
  visible: false
};

export default NewEmptyMessage;